import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ConfirmationModel = ({ open, handleOpen, SucessDelete }) => {
  return (
    <Dialog open={open} onClose={() => handleOpen(false)} maxWidth="xs" fullWidth>
      {/* Close Button */}
      <IconButton
        onClick={() => handleOpen(false)}
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
          color: " #212129",
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Typography sx={{ fontSize: "18px",fontWeight:600, color: "#212129", textAlign: "center" }}>
        Are You Sure You Want to Delete...?
        </Typography>
      </DialogContent>

      {/* Dialog Actions */}
      <DialogActions sx={{ justifyContent: "right", gap: 2, padding: "16px" }}>
        <Button
          onClick={() => handleOpen(false)}
          sx={{
            border: "1px solid  #212129",
            backgroundColor: "white",
            color: " #212129",
            borderRadius: "20px",
            px: 3,
            "&:hover": { backgroundColor: "#f0f0f0" },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{
            border: "1px solid  #212129",
            backgroundColor: " #212129",
            color: "white",
            borderRadius: "20px",
            px: 3,
            "&:hover": { backgroundColor: "#333" },
          }}
          onClick={SucessDelete}
        >
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModel;


